export default __webpack_public_path__ + "ae8bdf981617fb78e789bcff1f6fdd74.png";